// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- HS Code
import { QuestionsBaseService } from './questions-base.service';
import { QuestionModel } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class QuestionsMockService extends QuestionsBaseService {
  constructor() {
    super();
  }

  loadExtraValueQuestions(): void {
    let questions = new Array<QuestionModel>();

    questions = [
      { id: '1', text: 'Extra Value Question 1', index: 1, categoryId: 2, questionType: 3 },
      { id: '2', text: 'Extra Value Question 2', index: 2, categoryId: 3, questionType: 3 },
      { id: '3', text: 'Extra Value Question 3', index: 3, categoryId: 6, questionType: 3 },
      { id: '4', text: 'Extra Value Question 4', index: 4, categoryId: 8, questionType: 3 }];

    this.initialiseQuestions(questions);
  }

  loadQuestions(id: string): void {
    let questions = new Array<QuestionModel>();

    questions = [
      { id: '1',  text: 'Continuously tries to improve thinking and behaviour', index: 1, categoryId: 2, questionType: 1 },
      { id: '2',  text: 'Is dedicated and disciplined', index: 2, categoryId: 3, questionType: 1 },
      { id: '3',  text: 'Gets along well with others', index: 3, categoryId: 6, questionType: 1 },
      { id: '4',  text: 'Is willing to take time with people to develop them', index: 4, categoryId: 8, questionType: 1 },
      { id: '5',  text: 'Has genuine concern for others', index: 5, categoryId: 7, questionType: 1 },
      { id: '6',  text: 'Is sarcastic', index: 6, categoryId: 12, questionType: 1 },
      { id: '7',  text: 'Is abrupt', index: 7, categoryId: 9, questionType: 1 },
      { id: '8',  text: 'Does things for the approval of others', index: 8, categoryId: 13, questionType: 1 },
      { id: '9',  text: '<b><i>Needs</i></b> to be seen as a "good person"', index: 9, categoryId: 13, questionType: 1 },
      { id: '10', text: 'Sees any criticism as personal attack', index: 10, categoryId: 15, questionType: 1 },
      { id: '11', text: 'Obeys <i><b>too</b></i> willingly', index: 11, categoryId: 16, questionType: 1 },
      { id: '12', text: 'Avoids taking personal responsibility', index: 12, categoryId: 14, questionType: 1 },
      { id: '13', text: 'Seeks and takes opportunities for personal growth', index: 13, categoryId: 2, questionType: 1 },
      { id: '14', text: 'Is congruent - does what they say they will do', index: 14, categoryId: 3, questionType: 1 },
      { id: '15', text: 'Takes reasonable risk to attain effective results', index: 15, categoryId: 4, questionType: 1 },
      { id: '16', text: 'Relates well to others', index: 16, categoryId: 6, questionType: 1 },
      { id: '17', text: 'Actively encourages others', index: 17, categoryId: 5, questionType: 1 },
      { id: '18', text: 'Enjoys teaching others', index: 18, categoryId: 8, questionType: 1 },
      { id: '19', text: 'Is compassionate toward others', index: 19, categoryId: 7, questionType: 1 },
      { id: '20', text: 'Uses sarcastic humour to make a point', index: 20, categoryId: 12, questionType: 1 },
      { id: '21', text: 'Is boastful and egotistical', index: 21, categoryId: 10, questionType: 1 },
      { id: '22', text: 'Is domineering', index: 22, categoryId: 9, questionType: 1 },
      { id: '23', text: 'Tries <i><b>too</b></i> hard to prove self', index: 23, categoryId: 11, questionType: 1 },
      { id: '24', text: '<b><i>Needs</i></b> attention and praise', index: 24, categoryId: 13, questionType: 1 },
      { id: '25', text: 'Is easily hurt by others', index: 25, categoryId: 15, questionType: 1 },
      { id: '26', text: 'Seeks permission for almost everything', index: 26, categoryId: 16, questionType: 1 },
      { id: '27', text: 'Avoids dealing with conflict', index: 27, categoryId: 14, questionType: 1 },
      { id: '28', text: 'Is one\'s self around others', index: 28, categoryId: 1, questionType: 1 },
      { id: '29', text: 'Takes responsibility for personal growth', index: 29, categoryId: 2, questionType: 1 },
      { id: '30', text: 'Sees what needs to be done and takes action', index: 30, categoryId: 4, questionType: 1 },
      { id: '31', text: 'Is a good teacher', index: 31, categoryId: 8, questionType: 1 },
      { id: '32', text: 'Cares for others', index: 32, categoryId: 7, questionType: 1 },
      { id: '33', text: 'Takes responsibility to achieve goals', index: 33, categoryId: 4, questionType: 1 },
      { id: '34', text: 'Manipulates situations to enhance own position', index: 34, categoryId: 10, questionType: 1 },
      { id: '35', text: 'Acts forcefully, aggressively', index: 35, categoryId: 9, questionType: 1 },
      { id: '36', text: 'Becomes bitter easily', index: 36, categoryId: 15, questionType: 1 },
      { id: '37', text: 'Is easily insulted', index: 37, categoryId: 15, questionType: 1 },
      { id: '38', text: 'Avoids decisions', index: 38, categoryId: 14, questionType: 1 },
      { id: '39', text: 'Speaks the truth, frank and open', index: 39, categoryId: 1, questionType: 1 },
      { id: '40', text: 'Consistently studies to develop growth areas', index: 40, categoryId: 2, questionType: 1 },
      { id: '41', text: 'Is a dependable person', index: 41, categoryId: 3, questionType: 1 },
      { id: '42', text: 'Takes initiative when opportunities arise', index: 42, categoryId: 4, questionType: 1 },
      { id: '43', text: 'Genuinely compliments others', index: 43, categoryId: 5, questionType: 1 },
      { id: '44', text: 'Coaches others to broaden skills and capabilities', index: 44, categoryId: 8, questionType: 1 },
      { id: '45', text: 'Is sympathetic, without encouraging self-pity', index: 45, categoryId: 7, questionType: 1 },
      { id: '46', text: 'Uses humour to put people down', index: 46, categoryId: 12, questionType: 1 },
      { id: '47', text: 'Succeeds at the expense of others', index: 47, categoryId: 10, questionType: 1 },
      { id: '48', text: 'Is pushy', index: 48, categoryId: 9, questionType: 1 },
      { id: '49', text: 'Is stressed when doing tasks', index: 49, categoryId: 11, questionType: 1 },
      { id: '50', text: '<b><i>Needs</i></b> admiration', index: 50, categoryId: 13, questionType: 1 },
      { id: '51', text: 'Is easily upset in most situations', index: 51, categoryId: 15, questionType: 1 },
      { id: '52', text: 'Follows others’ values <i><b>too</b></i> easily', index: 52, categoryId: 16, questionType: 1 },
      { id: '53', text: 'Is indecisive, procrastinates', index: 53, categoryId: 14, questionType: 1 },
      { id: '54', text: 'Expresses self freely', index: 54, categoryId: 1, questionType: 1 },
      { id: '55', text: 'Is transparent about self', index: 55, categoryId: 1, questionType: 1 },
      { id: '56', text: 'Is a good communicator', index: 56, categoryId: 6, questionType: 1 },
      { id: '57', text: 'Is a good listener and encourager', index: 57, categoryId: 5, questionType: 1 },
      { id: '58', text: 'Develops others', index: 58, categoryId: 8, questionType: 1 },
      { id: '59', text: 'Is considerate', index: 59, categoryId: 7, questionType: 1 },
      { id: '60', text: 'Is dictatorial, autocratic', index: 60, categoryId: 9, questionType: 1 },
      { id: '61', text: '<b><i>Needs</i></b> to look busy and stressed', index: 61, categoryId: 11, questionType: 1 },
      { id: '62', text: '<b><i>Needs</i></b> to be liked by everyone', index: 62, categoryId: 13, questionType: 1 },
      { id: '63', text: 'Is over sensitive to the slightest "remark" from others', index: 63, categoryId: 15, questionType: 1 },
      { id: '64', text: 'Is easily influenced by others', index: 64, categoryId: 16, questionType: 1 },
      { id: '65', text: 'Runs away from responsibility', index: 65, categoryId: 14, questionType: 1 },
      { id: '66', text: 'Knows personal growth needs and seeks ways to develop', index: 66, categoryId: 2, questionType: 1 },
      { id: '67', text: 'Is reliable and steady', index: 67, categoryId: 3, questionType: 1 },
      { id: '68', text: 'Is friendly and approachable', index: 68, categoryId: 6, questionType: 1 },
      { id: '69', text: 'Praises others', index: 69, categoryId: 5, questionType: 1 },
      { id: '70', text: 'Assists others in solving problems', index: 70, categoryId: 8, questionType: 1 },
      { id: '71', text: 'Is kind and generous', index: 71, categoryId: 7, questionType: 1 },
      { id: '72', text: 'Uses sarcastic humour to pay compliments', index: 72, categoryId: 12, questionType: 1 },
      { id: '73', text: 'Exaggerates own performance and accomplishments', index: 73, categoryId: 10, questionType: 1 },
      { id: '74', text: 'Is bossy', index: 74, categoryId: 9, questionType: 1 },
      { id: '75', text: '<b><i>Needs</i></b> to be seen as highly competent', index: 75, categoryId: 11, questionType: 1 },
      { id: '76', text: 'Personal effectiveness', index: 1, categoryId: 17, questionType: 2 },
      { id: '77', text: 'Effectiveness at work', index: 2, categoryId: 17, questionType: 2 },
      { id: '78', text: 'Quality of relationships', index: 3, categoryId: 17, questionType: 2 },
      { id: '79', text: 'Time management effectiveness', index: 4, categoryId: 17, questionType: 2 },
      { id: '80', text: 'Stress', index: 5, categoryId: 17, questionType: 2 },
      { id: '81', text: 'Health', index: 6, categoryId: 17, questionType: 2 },
      { id: '82', text: 'Personal development', index: 7, categoryId: 17, questionType: 2 },
      { id: '83', text: 'Happiness', index: 8, categoryId: 17, questionType: 2 },
    ];

    this.initialiseQuestions(questions);
  }
}
